import {
  GET_LOCATIONS,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
  GET_HOME_CHARGERS,
  GET_HOME_CHARGERS_SUCCESS,
  GET_HOME_CHARGERS_FAILURE,
  SHOW_GLOBAL_LOADER,
  SHOW_GLOBAL_ERROR,
  CLEAR_GLOBAL_ERROR,
} from '../types';

const initialState = {
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_GLOBAL_LOADER:
    case CLEAR_GLOBAL_ERROR:
    case GET_LOCATIONS:
    case GET_LOCATIONS_SUCCESS:
    case GET_HOME_CHARGERS:
    case GET_HOME_CHARGERS_SUCCESS:
      return {
        error: false,
      };
    case SHOW_GLOBAL_ERROR:
    case GET_LOCATIONS_FAILURE:
    case GET_HOME_CHARGERS_FAILURE:
      return {
        error: true,
      };

    default:
      return state;
  }
};
